module.exports = __webpack_public_path__ + "static/media/bg_04.61c01eb0.jpg";